import { Alert } from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import { SvgIconComponent } from "@mui/icons-material";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import FlagCircleOutlinedIcon from "@mui/icons-material/FlagCircleOutlined";
type StatusType =
  | "initial"
  | "pending approval"
  | "approved for invoice"
  | "invoice generated"
  | "invoice collected"
  | "dispute"
  | "invoice not required"
  | "partially collected"
  | "reported as collected"
  | "bad debts"
  | string;

interface StatusConfig {
  severity: "info" | "success" | "warning" | "error";
  icon: SvgIconComponent;
  color: string;
  borderColor: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  initial: {
    severity: "info",
    icon: HourglassEmptyIcon,
    color: "#6B6B6B",
    borderColor: "#BDBDBD",
  },

  "pending approval": {
    severity: "info",
    icon: PendingOutlinedIcon,
    color: "#1976D2",
    borderColor: "#90CAF9",
  },

  "approved for invoice": {
    severity: "info",
    icon: ThumbUpOutlinedIcon,
    color: "#1976D2",
    borderColor: "#90CAF9",
  },

  "invoice generated": {
    severity: "info",
    icon: DescriptionOutlinedIcon,
    color: "#1976D2",
    borderColor: "#90CAF9",
  },

  "invoice collected": {
    severity: "success",
    icon: PaidOutlinedIcon,
    color: "#2E7D32",
    borderColor: "#A5D6A7",
  },

  dispute: {
    severity: "error",
    icon: ErrorOutlineOutlinedIcon,
    color: "#D32F2F",
    borderColor: "#EF9A9A",
  },

  "invoice not required": {
    severity: "success",
    icon: DoNotDisturbOnOutlinedIcon,
    color: "#2E7D32",
    borderColor: "#A5D6A7",
  },

  "partially collected": {
    severity: "warning",
    icon: AccountBalanceWalletOutlinedIcon,
    color: "#ED6C02",
    borderColor: "#FFCC80",
  },

  "reported as collected": {
    severity: "success",
    icon: AssignmentTurnedInOutlinedIcon,
    color: "#2E7D32",
    borderColor: "#A5D6A7",
  },

  "bad debts": {
    severity: "error",
    icon: FlagCircleOutlinedIcon,
    color: "#D32F2F",
    borderColor: "#EF9A9A",
  },
};

const DEFAULT_CONFIG: StatusConfig = {
  severity: "info",
  icon: PendingOutlinedIcon,
  color: "#757575",
  borderColor: "rgba(117, 117, 117, 0.5)",
};

interface FMEStatusProps {
  status: StatusType;
}

export default function FMEStatus({ status }: FMEStatusProps) {
  const config = STATUS_CONFIG[status] || DEFAULT_CONFIG;
  const IconComponent = config.icon;

  return (
    <div className="AlertItems">
      <Alert
        icon={<IconComponent />}
        severity={config.severity}
        sx={{
          border: `1px solid ${config.borderColor}`,
          padding: "0px 5px",
          //   display: "inline-flex",
          width: "fit-content",
          backgroundColor: `${config.color}15`,
          "& .MuiAlert-icon": {
            color: config.color,
          },
          "& .MuiAlert-message": {
            color: config.color,
            fontWeight: 500,
          },
        }}
      >
        {status
          ?.split(" ")
          ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          ?.join(" ") || ""}
      </Alert>
    </div>
  );
}
